import { render, staticRenderFns } from "./dangerJournalDetail.vue?vue&type=template&id=6a2b8f7f"
import script from "./dangerJournalDetail.vue?vue&type=script&lang=js"
export * from "./dangerJournalDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2b8f7f')) {
      api.createRecord('6a2b8f7f', component.options)
    } else {
      api.reload('6a2b8f7f', component.options)
    }
    module.hot.accept("./dangerJournalDetail.vue?vue&type=template&id=6a2b8f7f", function () {
      api.rerender('6a2b8f7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/env/danger/dangerJournalDetail.vue"
export default component.exports